(function( $ ) {
// Render maps on page load.
    $(document).ready(function(){
        $('.nav__hamburger').click(function(e){
            e.stopPropagation();
            $('body').toggleClass('o-hidden');
            $(this).toggleClass('nav__hamburger-open');
            $(this).parent().find('.nav__menu').toggleClass('menu-open');
        });
        $('.menu-item a').click(function(){
            $('body').removeClass('o-hidden');
            $('.nav__hamburger').removeClass('nav__hamburger-open');
            $('.nav__menu').removeClass('menu-open');
        });
    });

    $(window).scroll(function(e) {
        e.preventDefault();
        if ($(window).scrollTop() > 100) {
            $('.navigation').addClass("scrolled");
        } else {
            $('.navigation').removeClass("scrolled");
        }
    });

    // Script
    let lastScroll = 0;
    $(window).on('scroll',function() {
        var scroll = $(window).scrollTop();
        if(lastScroll - scroll > 0) {
            $(".navigation").addClass("scrollUp");
            if ($(window).scrollTop() < 20) {
                    $('.navigation').removeClass("scrolled-anim");
            }
        } else {
            $(".navigation").removeClass("scrollUp");
            if ($(window).scrollTop() > 100) {
                setTimeout(() => {
                    $('.navigation').addClass("scrolled-anim");
                }, 200)
            }
        }
        lastScroll = scroll;
    });

})(jQuery);